import { Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import {
  AdminDashboard,
  AdminLegalDocuments,
  CompanyManager,
  HpcFlows,
  HpcKeys,
  Manager,
  MoveMember,
  ServicesManager,
  TagsManager,
} from "./lazyPages";

// Plain render helper (not a component): <Routes> only accepts <Route>/Fragment children.
export function renderAdminRoutes({
  user,
  canManageLegalDocuments,
  canAccessAdminArea,
  canMoveMembers,
}) {
  return (
    <>
      {canManageLegalDocuments && (
        <Route
          path="/admin/legal-documents"
          element={
            <ProtectedRoute>
              <AdminLegalDocuments />
            </ProtectedRoute>
          }
        />
      )}
      {canAccessAdminArea && (
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      )}

      {canAccessAdminArea && (
        <Route
          path="/admin/manager"
          element={
            <ProtectedRoute>
              <Manager />
            </ProtectedRoute>
          }
        />
      )}

      {canAccessAdminArea && (
        <Route
          path="/admin/manager/company/:companyId"
          element={
            <ProtectedRoute>
              <CompanyManager />
            </ProtectedRoute>
          }
        />
      )}
      {user?.role === "sysAdmin" && (
        <Route
          path="/admin/tags"
          element={
            <ProtectedRoute>
              <TagsManager />
            </ProtectedRoute>
          }
        />
      )}
      {/* Only sysAdmin can access services management */}
      {user?.role === "sysAdmin" && (
        <Route
          path="/admin/services"
          element={
            <ProtectedRoute>
              <ServicesManager />
            </ProtectedRoute>
          }
        />
      )}
      {user?.role === "sysAdmin" && (
        <Route
          path="/admin/hpc-flows/*"
          element={
            <ProtectedRoute>
              <HpcFlows admin />
            </ProtectedRoute>
          }
        />
      )}
      {user?.role === "sysAdmin" && (
        <Route
          path="/admin/hpc-keys"
          element={
            <ProtectedRoute>
              <HpcKeys />
            </ProtectedRoute>
          }
        />
      )}
      {canMoveMembers && (
        <Route
          path="/admin/move-member"
          element={
            <ProtectedRoute>
              <MoveMember />
            </ProtectedRoute>
          }
        />
      )}
    </>
  );
}
